<script>
  import HomeContent from "../components/Home/HomeContent.svelte";
  import HomeSelect from "../components/Home/HomeSelect.svelte";
</script>

<div>
  <HomeContent />
  <HomeSelect />
</div>

<style type="text/scss">
  div {
    padding-bottom: 30px;
  }
</style>
